import { getTheme } from 'utils/themes';
import BaseChart from '../baseChart';

// type Props = {
//   /** An additional class. */
//   className?: string,
//   /* Series Data array pie chart */
//   data: any,
//   /* Set additional options for pie chart. */
//   options: {},
//   /* Theme of the pie chart. */
//   theme: string,
// };

const defaultProps = {
  theme: 'default',
};

export default function Pie(props) {
  const { className, data, options, theme, ...otherProps } = props;

  const themeDef = getTheme(theme);

  const defaultOptions = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        borderWidth: 0,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.percentage:.1f} %',
          shadow: false,
          style: {
            color: themeDef.textColor,
            textOutline: false,
          },
        },
        colors: [
          'rgb(0, 64, 112)',
          'rgb(48, 103, 145)',
          '#5f92b7',
          'rgb(133, 180, 214)',
          'rgb(163, 215, 255)',
        ],
      },
    },
  };

  return (
    <BaseChart
      className={className}
      chartType="pie"
      data={data}
      defaultOptions={defaultOptions}
      options={options}
      theme={theme}
      {...otherProps}
    />
  );
}

Pie.defaultProps = defaultProps;
